module.exports = __webpack_public_path__ + "img/wallet.a3302bb0.png";